import FanCardModalComponent from "./FanCardModalComponent";

export default FanCardModalComponent;